/* Footer Menu Block JS File */
$(document).ready(function() {

});
